import { EPaymentGroup } from '@model';

export const isCashOrCreditCard = (paymentGroups: EPaymentGroup[]) =>
  isInGroup(paymentGroups, EPaymentGroup.CASH_OR_CREDIT_CARD);

export const isCashOnDelivery = (paymentGroups: EPaymentGroup[]) =>
  isInGroup(paymentGroups, EPaymentGroup.CASH_ON_DELIVERY);
export const isBankTransfer = (paymentGroups: EPaymentGroup[]) => isInGroup(paymentGroups, EPaymentGroup.BANK_TRANSFER);
export const isNovaGlobal = (paymentGroups: EPaymentGroup[]) => isInGroup(paymentGroups, EPaymentGroup.NOVA_GLOBAL);

export const isGoPayBankTransfer = (paymentGroups: EPaymentGroup[]) =>
  isInGroup(paymentGroups, EPaymentGroup.GO_PAY_BANK_TRANSFER);

export const isAdyenCreditCard = (paymentGroups: EPaymentGroup[]) =>
  isInGroup(paymentGroups, EPaymentGroup.ADYEN_CREDIT_CARD);

export const isPrzelewy24 = (paymentGroups: EPaymentGroup[]) => isInGroup(paymentGroups, EPaymentGroup.PRZELEWY24);
export const isPaypo = (paymentGroups: EPaymentGroup[]) => isInGroup(paymentGroups, EPaymentGroup.PRZELEWY24_PAYPO);

export const isDisableForEngraving = (paymentGroups: EPaymentGroup[]) =>
  isInGroup(paymentGroups, EPaymentGroup.DISABLE_FOR_ENGRAVING);

export const isPaypal = (paymentGroups: EPaymentGroup[]) => isInGroup(paymentGroups, EPaymentGroup.PAYPAL);

export const isAdyenWebComponent = (paymentGroups: EPaymentGroup[]) =>
  isInGroup(paymentGroups, EPaymentGroup.ADYEN_WEB_COMPONENTS);

export const isTokenPayment = (paymentGroups: EPaymentGroup[]) => isInGroup(paymentGroups, EPaymentGroup.TOKEN_PAYMENT);

const isInGroup = (paymentGroups: EPaymentGroup[], group: EPaymentGroup) => paymentGroups.includes(group);

export const isPaypalTokenizedPayment = (groups: EPaymentGroup[]) => isPaypal(groups) && isTokenPayment(groups);
export const isPrzelewy24OrPaypo = (groups: EPaymentGroup[]) => isPrzelewy24(groups) || isPaypo(groups);
